import { gql, useQuery } from '@apollo/client'

import {
  GachaTicketOrdersConnectionFragmentDoc,
  TicketOrdersQuery,
  TicketOrdersQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { data, loading, fetchMore } = useQuery<
    TicketOrdersQuery,
    TicketOrdersQueryVariables
  >(QUERY)

  return {
    state: {
      loading,
      hasNextPage: !!data?.gachaTicketOrders?.pageInfo.hasNextPage,
      gachaTicketOrders: data?.gachaTicketOrders ?? null,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            pageInput: {
              cursor: data?.gachaTicketOrders?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query TicketOrders($pageInput: PageInput) {
    gachaTicketOrders(pageInput: $pageInput) {
      ...GachaTicketOrdersConnection
    }
  }
  ${GachaTicketOrdersConnectionFragmentDoc}
`
